import { TranslatableText } from '@dreryk/react-common';
import { Button, ButtonVariant } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';
import { BlockedAccountTooltip } from '~libs.desktop.shared.account';

import { AccountConfigurationVerificationEventInterceptorConstructor } from '../types';
import { MedicalTreatmentConsentEnterEventInterceptor } from '../interceptors/MedicalTreatmentConsentEnterEventInterceptor';
import { PatientDataUpdateBeforeVisitEventInterceptor } from '../interceptors/PatientDataUpdateBeforeVisitEventInterceptor';
import { PatientExternalIdentifierTypeStillValidEventInterceptor } from '../interceptors/patientExternalIdentifierTypeStillValid/PatientExternalIdentifierTypeStillValidEventInterceptor';
import { translationKeys } from '../translations';

type VisitEnterButtonProps = {
   readonly patientId: number;
   readonly accountConfigurationVerificationEventInterceptor: AccountConfigurationVerificationEventInterceptorConstructor;
   readonly label: TranslatableText;
   readonly testId: string;
   readonly onClick: VoidFunction | (() => Promise<void>);
   readonly disabled?: boolean;
   readonly compact?: boolean;
   readonly variant?: ButtonVariant;
   readonly goBackButtonLabel?: TranslatableText;
   readonly appointmentId?: number;
};

export const VisitEnterButton = (props: VisitEnterButtonProps): JSX.Element => {
   const {
      accountConfigurationVerificationEventInterceptor: AccountConfigurationVerificationEventInterceptor,
      ...buttonProps
   } = props;

   const creatingVisitAvailable = protectFeature('creatingVisits', true, false);

   return (
      <AccountConfigurationVerificationEventInterceptor>
         <PatientDataUpdateBeforeVisitEventInterceptor
            appointmentId={props.appointmentId}
            patientId={props.patientId}
            goBackButtonLabel={props.goBackButtonLabel ?? translationKeys.goBackToAppointmentsList}
         >
            <MedicalTreatmentConsentEnterEventInterceptor patientId={props.patientId}>
               <PatientExternalIdentifierTypeStillValidEventInterceptor patientId={props.patientId}>
                  <BlockedAccountTooltip disabled={creatingVisitAvailable} testId={'enterVisit'}>
                     <Button {...buttonProps} disabled={buttonProps.disabled || !creatingVisitAvailable} />
                  </BlockedAccountTooltip>
               </PatientExternalIdentifierTypeStillValidEventInterceptor>
            </MedicalTreatmentConsentEnterEventInterceptor>
         </PatientDataUpdateBeforeVisitEventInterceptor>
      </AccountConfigurationVerificationEventInterceptor>
   );
};
